import React from 'react';
import { Pipeline } from 'components/pipeline/Pipeline';
import { PipelineItem } from 'components/pipeline/PipelineItem';
import { Divider } from 'components/elements/divider/Divider';

export const Component = () => {
  return (
    <>
      <Divider>Pipeline</Divider>
      <Pipeline
      // title="Pipline information"
      // text={
      //   <p>
      //     Our strategy is focused on five key pillars, incorporated in our culture and in our
      //     daily work.
      //   </p>
      // }
      // footnotes={
      //   <>
      //     <p>*Licenced from Biosana</p>
      //     <p>HUMIRA is registered trademark of AbbVie Inc.</p>
      //     <p>
      //       STELARA and SIMPONI are registered trademarks of Janssen Biotech, Inc. XOLAIR is a
      //       registered trademark of Novartis AG
      //     </p>
      //     <p>PROLINA and XGEVA are registered trademarks of Amgen, Inc.</p>
      //     <p>EYLEA is a registered trademark of Regeneron Pharmaceuticals, Inc.</p>
      //   </>
      // }
      >
        <PipelineItem
          title="AVT02"
          biosimilarCandidate="High-concentration adalimumab"
          referenceBiologic="HUMIRA®"
          therapeuticArea="Immunology"
          approvals={[{ name: 'CHMP' }, { name: 'Health Canada' }]}
          currentStage="Approval"
        />
        <PipelineItem
          title="AVT04"
          biosimilarCandidate="ustekinumab"
          referenceBiologic="STELARA®"
          therapeuticArea="Immunology"
          currentStage="Pivotal Clinical Trials"
        />
        <PipelineItem
          title="AVT23*"
          biosimilarCandidate="omalizumab"
          referenceBiologic="XOLAIR®"
          therapeuticArea="Respiratory"
          currentStage="Early Clinical Trials"
        />
        <PipelineItem
          title="AVT03"
          biosimilarCandidate="densosumab"
          referenceBiologic="PROLIA/XGEVA®"
          therapeuticArea="Immunilogy/Oncology"
          currentStage="Pre-clinical"
        />
      </Pipeline>
    </>
  );
};
